/* 單獨列傳：馬超傳（設計見 docs/CAMPAIGN-MACHAO.md）
 * 這一條列傳自己的章節、地圖都在這個檔案登錄，不用改 campaign/index.ts。
 * 地圖 id 一律加前綴「machao_」，免得和其他列傳撞名。 */
// @ts-nocheck
import machao1 from '../story/machao1.ts';
import machao2a from '../story/machao2a.ts';
import machao2 from '../story/machao2.ts';
import machao3a from '../story/machao3a.ts';
import machao3 from '../story/machao3.ts';
import machao4 from '../story/machao4.ts';
import machao5a from '../story/machao5a.ts';
import machao5 from '../story/machao5.ts';
import machao6 from '../story/machao6.ts';
import pingyang from '../maps/machao_pingyang.ts';
import puban from '../maps/machao_puban.ts';
import weinan from '../maps/machao_weinan.ts';
import jicheng from '../maps/machao_jicheng.ts';
import chengdu from '../maps/machao_chengdu.ts';

export default {
  list: { id: 'machao', name: '馬超傳', years: '202–214', ready: true, parts: [
    { name: '關西篇', chapters: ['machao-1', 'machao-2a', 'machao-3a', 'machao-4'] },
    { name: '隴上篇', chapters: ['machao-5a', 'machao-6'] },
  ] },
  chapters: [machao1, machao2a, machao2, machao3a, machao3, machao4, machao5a, machao5, machao6],
  maps: { machao_pingyang: pingyang, machao_puban: puban, machao_weinan: weinan, machao_jicheng: jicheng, machao_chengdu: chengdu },
};
